// src/components/Layouts/MainLayout.jsx
import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';

const MainLayout = ({ children }) => (
  <>
    <Header />
    <main className='main-layout'>{children}</main>
    <div className='dashboard-ftr-wrap main-layout-footer'>
    <Footer />
    </div>
  </>
);

export default MainLayout;
